import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LipEcouponHeaderComponent } from '@web-nx-ng-tsc/ecoupon';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
@Component({
  imports: [RouterModule, LipEcouponHeaderComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly loggingService = inject(LoggingService);

  imgHeader = signal<string>('/assets/images/img-ecoupon-header.png');
  title = 'ecoupon-toyo';

  constructor() {
    this.loggingService.warn('NG_APP_ENV', import.meta.env.NG_APP_ENV);
  }
}
